// extracted by mini-css-extract-plugin
export default {"price-range-input__label":"price-range-input-module__price-range-input__label___m66dS"};